import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { TelefonoModule } from "../../components/telefono/telefono.module";
import { AutorizadorModule } from "../../components/autorizador/autorizador.module";
import { ContactoService } from "../../providers/contacto.service";
import { VerExamenComponent } from "./ver-examen/ver-examen.component";

import { ExamenService } from "../../providers/examen.service";
import { CrearExamenComponent } from "./crear-examen/crear-examen.component";
import { CrearExamenDialogComponent } from "./crear-examen/crear-examen-dialog/crear-examen-dialog.component";
import { EditarExamenComponent } from "./editar-examen/editar-examen.component";
import { EditarExamenDialogComponent } from "./editar-examen/editar-examen-dialog/editar-examen-dialog.component";
import { ExamenComponent } from "./examen/examen.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        TelefonoModule,
        AutorizadorModule,
    ],
    declarations: [
        CrearExamenComponent,
        CrearExamenDialogComponent,
        EditarExamenComponent,
        EditarExamenDialogComponent,
        ExamenComponent,
        VerExamenComponent
    ],
    providers: [
        ExamenService
    ],
    entryComponents: [
        CrearExamenDialogComponent,
        EditarExamenDialogComponent,
    ],
    exports: [
        CrearExamenComponent,
        EditarExamenComponent,
        ExamenComponent,
        VerExamenComponent,
    ]
})
export class ExamenEModule { }